import Footer from "./../components/Footer";

function About() {
	return (
		<>
			<section className="about__container">
				<div className="about__inner">
					<div className="about__photo"></div>


					<div className="about__content">
						<h1 className="about__title brand-display xxl">hey!</h1>
						
						<p>
						I'm Rachael - a front-end developer and accessibility advocate with a passion for building 
						inclusive digital experiences. My work blends creativity with hands‑on engineering: 
						architecting accessible components, shaping CMS schema and layout logic, and ensuring 
						structured content becomes semantic, user‑centred UI.
						</p>

						<p>
						In my current role, I’ve been the sole front‑end developer on several large‑scale government 
						and corporate projects, including the Department of Transport and Major Infrastructure, the 
						City of Mandurah, and APM Australia. I work end‑to‑end across the delivery pipeline: designing 
						CMS property structures, implementing null‑safe rendering logic, writing documentation, leading 
						QA, and driving accessibility strategy. My practice includes WCAG 2.1 and 2.2 audits, design 
						teardowns, and collaborative remediation that balances technical rigour with practical, human‑
						centred outcomes.
						</p>

						<p>
						Before diving into digital accessibility, I studied at Curtin University, earning awards for 
						design and academic excellence - including the DIGEX Industry Award from Equ (2022), 1st Place 
						in the Curtin Creative Jam (2021), and admission to the Vice-Chancellor’s List.
						</p>

						<p>
						I thrive in collaborative teams full of curious, quirky minds who care deeply about the user. 
						With a background in web development, UX, QA, and design, I bring a proactive, detail-driven 
						approach to everything I build. I believe great digital products should be intuitive, empowering, 
						and accessible to everyone.
						</p>

						<p>
						Outside of work, I spend time with my wonderful partner and stepdaughter, alternating between 
						his warm family home (complete with cuddly cats) and my quiet creative haven. I unwind by sewing, 
						sketching, and escaping into RuneScape or Star Trek. I’m happiest when imagination meets comfort.
						</p>
					</div>

					<div className="about__notice">
						<p className="bold-italic">A Quick Note While I Rebuild</p>
						<p>
						This website is currently being rebuilt after several years of neglect. I’m in the process of 
						redesigning and modernising the site to reflect the standards I advocate for in my work, and I appreciate 
						your patience while it evolves.
						</p>
					</div>
				</div>
				<Footer />
			</section>
		</>
	);
}

export default About;
